import _objectSpread from "/root/ONLINE_SERVICE/other/ferry/task_workspace/baidu/map-ai-native/feed-h5/node_modules/.pnpm/@babel+runtime@7.23.2/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import { addPvNew, isBaiduMap } from '../../../../utils';
import itemCard from './components/itemCard';
import { openUrlByOpenApi } from '@baidu/map-fe-utils';
import moreCard from './components/moreCard';
import { mapGetters } from 'vuex';
export default {
  components: {
    itemCard,
    moreCard
  },
  props: {
    skuDataList: {
      type: Array,
      default: () => []
    },
    unique_id: {
      type: String,
      default: ''
    },
    // 列表主题
    theme: {
      type: String,
      default: () => {
        return '';
      }
    },
    tpSource: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      isBaiduMap: isBaiduMap(),
      clickType: ''
    };
  },
  computed: _objectSpread(_objectSpread({}, mapGetters(['is_dark'])), {}, {
    themeClass() {
      switch (this.theme) {
        case 'dark':
          // 黑色主题
          return 'dark-theme-list';
      }
      // 默认白色主题
      return '';
    },
    skuData() {
      if (this.skuDataList.length === 1) {
        return this.skuDataList[0];
      } else if (this.skuDataList.length > 1 && this.skuDataList.length < 6) {
        return this.skuDataList;
      }
      return this.skuDataList.slice(0, 5);
    },
    skuCouponType() {
      if (this.skuDataList.length === 0) {
        return;
      }
      return this.skuDataList[0].coupon_type;
    },
    skuType() {
      const validTypes = ['car_4s', 'car_newenergy', 'house_old', 'house_xinfang'];
      return validTypes.includes(this.skuDataList[0].sku_type);
    },
    isHouse() {
      const validTypes = ['house_old', 'house_xinfang'];
      return validTypes.includes(this.skuDataList[0].sku_type);
    },
    isCar() {
      const validTypes = ['car_4s', 'car_newenergy'];
      return validTypes.includes(this.skuDataList[0].sku_type);
    },
    call_icon() {
      return this.is_dark ? this.skuData.ext.button_dark_icon : this.skuData.ext.button_icon;
    },
    all_text() {
      if (this.skuDataList.length > 0) {
        return {
          first_text: this.skuDataList[0].bottom_text.substring(0, 2),
          second_text: this.skuDataList[0].bottom_text.substring(2)
        };
      }
      return null;
    }
  }),
  mounted() {
    // 展现埋点
    this.buryHandle('show');
  },
  methods: {
    /**
     * 跳转购买商品详情页
     *
     * @returns {void}
     */
    goPurchase(url, type) {
      if (!this.isBaiduMap) {
        this.$emit('open-Baidu-Map');
        return;
      }
      this.clickType = type;
      this.buryHandle('click');
      openUrlByOpenApi(url);
    },
    /**
     * 跳转详情页，查看更多优惠
     *
     * @returns {void}
     */
    purchaseMore(url) {
      if (!this.isBaiduMap) {
        this.$emit('open-Baidu-Map');
        return;
      }
      this.buryHandle('click', 'more');
      openUrlByOpenApi(url);
    },
    buryHandle(type, status) {
      let action = ['MCEDse.NewMedia.detailspage.sku'].concat(status ? [status] : []).concat(type ? [type] : []);
      addPvNew(action, {
        std_tag: this.skuData.std_tag,
        poi_uid: this.skuData.poi_uid,
        feed_id: this.unique_id,
        tp: this.tpSource,
        skutype: this.skuData.sku_type,
        type: this.clickType
      });
    }
  }
};